module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_5010.4454095e.png";